import SLIDER from "../class/slider";

const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ];

const init = () => {
  // gallery
  const gallery = new SLIDER({
    obj: '[data-plugin="gallery"]',
    slickOpt: {
      autoplay: false,
      adaptiveHeight: true,
      speed: 500,
    }
  });
  gallery.init();

  const $subgalleryItem = $('.project-article-subgallery__img-cover');
  const subgalleryItemHandler = obj => {
    const index = obj.dataset.galleryIndex;
    $(obj).on('click', () => $(gallery.obj).slick('slickGoTo', index ) );
  }
  $subgalleryItem.each( (i,v) => subgalleryItemHandler(v) )
}

export default function PROJECT () {
  d.addEventListener('DOMContentLoaded', init );
}